import { render, staticRenderFns } from "./IconHelp.vue?vue&type=template&id=0072c59a&scoped=true&"
import script from "./IconHelp.vue?vue&type=script&lang=js&"
export * from "./IconHelp.vue?vue&type=script&lang=js&"
import style0 from "./IconHelp.vue?vue&type=style&index=0&id=0072c59a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0072c59a",
  null
  
)

export default component.exports